import { Component, OnInit, OnDestroy } from '@angular/core';
import { AppService } from './../../../../../../../src/app/modules/shared/services/geral/app.service';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { SubSink } from 'subsink';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-cadastro-poderes-cliente',
  templateUrl: './cadastro-poderes-cliente.component.html',
  styleUrls: ['./cadastro-poderes-cliente.component.css']
})
export class CadastroPoderesClienteComponent implements OnInit, OnDestroy {

  constructor(public svc: AppService, private activatedRoute: ActivatedRoute, private tl: TranslateService) { }

  public tipo_manutencao_autorizadores: string;
  public tipo_manutencao_docs: string;
  public tipo_manutencao_seq: string = "I";
  public tipo_manutencao_poder: string = "I";
  public colsAutorizadores: any[];
  public colsDocs: any[];
  public autorizadores: any[];
  public documentos: any[];
  public tipos_processo_lista: any[] = [];
  public documentos_lista: any[] = [];
  public procuradores_lista: any[];
  public cliente: any;
  public poderes: any[];
  public docAnexo: File[] = [];
  public docVazio: boolean = false;
  public dropVazio: boolean = false;
  public faixas_erro: boolean = false;
  public faixas_erro_desc: string = "";
  public tipos_processo_erro: boolean = false;
  public tipo_processo_repetido: boolean = false;
  public possui_limite: string = "";
  public valor_inicial: string = "";
  public valor_final: string = "";
  private sub = new SubSink();
  public date: Date = new Date();
  public spinProcessos = true;
  public spinAuto = true;
  public spinDoc = true;
  public spinAutoCRUD = false;
  public spinUploadCRUD = false;
  public spinPoderesCRUD = false;

  public sbRetornarFiltros(lista: any[], column: string): any {
    var retorno = [];

    if (lista) {
      for (let i = 0; i < lista.length; i++) {
        retorno.push(lista[i][column]);
      }

      retorno = retorno.filter(function (value, index) { return retorno.indexOf(value) == index });

      for (let i = 0; i < retorno.length; i++) {
        retorno[i] = { label: retorno[i], value: retorno[i] }
      }
    }

    return retorno;
  }

  public sbAbrirModal(event: Event): void {
    try {
      var id = $(event.target).attr("data-modal");
      this.svc.sbAbrirModal(id);
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
    }
  };

  //#region Poderes
  public sequencia_lista = [];

  public nova_sequencia: any = {
    index: -1,
    sequencia: "",
    codigo_autorizador: "",
    nome_autorizador: "",
    codigo_procurador: 0,
    nome_procurador: "",
    documentos: [],
    testemunha: false
  };

  public novo_poder: any = {
    id_cliente: -1,
    processos: [
      {
        id_tipo_processo: -1,
        faixas_limite: [
          {
            id_faixa: -1,
            valor_inicial: this.valor_inicial,
            valor_final: this.valor_final,
            autorizadores: this.sequencia_lista
          }
        ]
      }
    ]
  };

  //Alterar Valor Combo
  public changeProcurador(event) {
    try {
      var novo_text = event.target.item(event.target.selectedIndex).text;
      if (novo_text.toLowerCase() == "selecione") {
        this.nova_sequencia.nome_procurador = "";
        this.nova_sequencia.codigo_procurador = 0;
      } else {
        this.nova_sequencia.nome_procurador = novo_text;
      }
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
    }
  }

  //Alterar Valor Combo
  public changeAutorizador(event) {
    try {
      this.nova_sequencia.nome_autorizador = event.target.item(event.target.selectedIndex).text;
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
    }
  }

  //Alterar Valor Combo
  public changeTipoProcesso(event) {
    try {
      let id_tipo_processo = this.novo_poder.processos[0].id_tipo_processo;

      this.tipos_processo_lista.forEach(item => {
        if (item.id_processo == id_tipo_processo) {
          this.possui_limite = item.limite.toLowerCase();
          return false;
        }
      });

      this.tipo_processo_repetido = false;
      this.tipos_processo_erro = false;
      this.poderes.forEach(item => {
        if (item.id_processo == id_tipo_processo) {
          if (!item.possui_limite) {
            this.tipo_processo_repetido = true;
            this.tipos_processo_erro = true;
            this.svc.sbExibirNotificacao("warning", this.tl.instant("geral.mensagens.atencao"), this.tl.instant("cadastro_poderes.mensagens.poder_repetido"));
            return false;
          }
        }
      });
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
    }
  }

  //Cancelar
  public cancelarSequencia(f: NgForm) {
    try {
      this.limparFormSeq(f, null);
      this.tipo_manutencao_seq = "I";
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
    }
  }

  //Editar
  public editarSequencia(data, f: NgForm) {
    try {
      this.limparFormSeq(f, Object.assign({}, data));
      this.tipo_manutencao_seq = "A";
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
    }
  }

  //Escluir
  public excluirSequencia(data, f: NgForm) {
    try {
      this.limparFormSeq(f, Object.assign({}, data));
      this.tipo_manutencao_seq = "E";
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
    }
  }

  //Quando Documento for Alterado
  public changeDoc(event) {
    if (this.nova_sequencia.documentos.length > 0) {
      this.docVazio = false;
    } else {
      this.docVazio = true;
    }
  }

  public limparFormSeq(f: NgForm, data) {
    f.reset();

    this.docVazio = false;
    var that = this;
    setTimeout(() => {
      if (data == null) {
        that.nova_sequencia = {
          index: -1,
          sequencia: "",
          codigo_autorizador: "",
          nome_autorizador: "",
          codigo_procurador: 0,
          nome_procurador: "",
          documentos: [],
          testemunha: false
        };
      } else {
        that.nova_sequencia = data;
      }
    }, 100);
  }

  public excluir_sequencia(f: NgForm) {
    try {
      this.sequencia_lista.forEach((item, index) => {
        if (item.index == this.nova_sequencia.index) {
          this.sequencia_lista.splice(index, 1);
          return false;
        }
      });

      //reseta a sequência
      this.sequencia_lista.forEach((item, index) => {
        this.sequencia_lista[index].index = index;
      });

      this.limparFormSeq(f, null);
      this.tipo_manutencao_seq = "I";
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
    }
  }

  public salvar_sequencia(f: NgForm) {
    try {
      //Verifica se o Formulário está Válido
      if (f.valid) {
        if (this.nova_sequencia.documentos.length == 0 && !this.nova_sequencia.testemunha) {
          this.docVazio = true;
        } else {
          this.docVazio = false;
          let fl_existe: boolean = false;
          let indice: number = -1;
          this.sequencia_lista.forEach(item => {
            if (item.index != this.nova_sequencia.index) {
              if (item.codigo_autorizador == this.nova_sequencia.codigo_autorizador) {
                fl_existe = true;
                return false;
              }
            }
          });

          if (fl_existe) {
            this.svc.sbExibirNotificacao("warning", this.tl.instant("geral.mensagens.atencao"), this.tl.instant("cadastro_poderes.mensagens.autorizador_repetido"));
          } else {
            this.sequencia_lista.forEach((item, index) => {
              if (item.index == this.nova_sequencia.index) {
                this.sequencia_lista[index] = Object.assign({}, this.nova_sequencia);
                return false;
              }
            });

            this.limparFormSeq(f, null);
            this.tipo_manutencao_seq = "I";
          }
        }
      } else {
        if (this.nova_sequencia.documentos.length == 0) {
          this.docVazio = true;
        }
        //Marca todos os campos como Inválidos
        (<any>Object).values(f.controls).forEach(control => {
          control.markAsTouched();
        });
      }
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
    }
  }

  public adicionar_sequencia(f: NgForm) {
    try {
      this.tipo_manutencao_seq = "I";
      //Verifica se o Formulário está Válido
      if (f.valid) {
        if (this.nova_sequencia.documentos.length == 0 && !this.nova_sequencia.testemunha) {
          this.docVazio = true;
        } else {
          this.docVazio = false;
          let fl_existe: boolean = false;
          this.sequencia_lista.forEach(item => {
            if (item.codigo_autorizador == this.nova_sequencia.codigo_autorizador) {
              fl_existe = true;
              return false;
            }
          });

          if (fl_existe) {
            this.svc.sbExibirNotificacao("warning", this.tl.instant("geral.mensagens.atencao"), this.tl.instant("cadastro_poderes.mensagens.autorizador_repetido"));
          } else {
            this.nova_sequencia.index = this.sequencia_lista.length;
            this.sequencia_lista.push(Object.assign({}, this.nova_sequencia));
            this.limparFormSeq(f, null);
          }
        }
      } else {
        if (this.nova_sequencia.documentos.length == 0) {
          this.docVazio = true;
        }
        //Marca todos os campos como Inválidos
        (<any>Object).values(f.controls).forEach(control => {
          control.markAsTouched();
        });
      }
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
    }
  }

  public limparCamposPoder(f: NgForm) {
    try {
      this.sequencia_lista = [];
      this.limparFormSeq(f, null);
      this.tipo_manutencao_poder = "I";
      this.tipo_manutencao_seq = "I"
      this.valor_inicial = "";
      this.valor_final = "";
      this.faixas_erro = false;
      this.faixas_erro_desc = "";
      this.tipos_processo_erro = false;
      this.possui_limite = "não";
      this.novo_poder = {
        id_cliente: -1,
        processos: [
          {
            id_tipo_processo: -1,
            faixas_limite: [
              {
                id_faixa: -1,
                valor_inicial: this.valor_inicial,
                valor_final: this.valor_final,
                autorizadores: this.sequencia_lista
              }
            ]
          }
        ]
      };
    } catch (e) {
      throw e;
    }
  }

  public fnValidarPoder(): boolean {
    try {
      let fl_valido = true;
      this.tipos_processo_erro = false;
      this.faixas_erro = false;
      this.faixas_erro_desc = "";

      if (this.novo_poder.processos[0].id_tipo_processo == -1) {
        fl_valido = false;
        this.tipos_processo_erro = true;
      }

      if (this.possui_limite.toLowerCase() == "sim") {
        if (this.valor_inicial == "" || this.valor_final == "") {
          fl_valido = false;
          this.faixas_erro = true;
          this.faixas_erro_desc = this.tl.instant("cadastro_poderes.mensagens.informe_limite");
        } else {
          var vl_inicial = parseInt(this.svc.fnRemoverMascara(this.valor_inicial)) / 100;
          var vl_final = parseInt(this.svc.fnRemoverMascara(this.valor_final)) / 100;
          if (vl_final < vl_inicial) {
            fl_valido = false;
            this.faixas_erro = true
            this.faixas_erro_desc = this.tl.instant("cadastro_poderes.mensagens.limite_invalido");
          }
        }
      }

      if (this.tipo_manutencao_poder == "I") {
        if (this.tipo_processo_repetido) {
          this.tipos_processo_erro = true;
          fl_valido = false;
        }
      }

      if (this.sequencia_lista.length == 0) {
        fl_valido = false;
      }

      if (!fl_valido) {
        if (this.sequencia_lista.length == 0) {
          this.svc.sbExibirNotificacao("warning", this.tl.instant("geral.mensagens.atencao"), this.tl.instant("cadastro_poderes.mensagens.informe_sequencia"));
        } else if (this.tipo_processo_repetido && this.tipo_manutencao_poder == "I") {
          this.svc.sbExibirNotificacao("warning", this.tl.instant("geral.mensagens.atencao"), this.tl.instant("cadastro_poderes.mensagens.poder_repetido"));
        } else {
          this.svc.sbExibirNotificacao("warning", this.tl.instant("geral.mensagens.atencao"), this.tl.instant("geral.mensagens.campos_vermelho"));
        }
      }

      return fl_valido;
    } catch (e) {
      throw e;
    }
  }

  //salvar poder
  public processarPoder() {
    try {
      var limite_valido = true;
      if (this.fnValidarPoder()) {
        if (this.possui_limite == "sim") {
          this.novo_poder.processos[0].faixas_limite[0].valor_inicial = parseInt(this.svc.fnRemoverMascara(this.valor_inicial));
          this.novo_poder.processos[0].faixas_limite[0].valor_final = parseInt(this.svc.fnRemoverMascara(this.valor_final));
        } else {
          this.novo_poder.processos[0].faixas_limite[0].valor_inicial = parseInt("0");
          this.novo_poder.processos[0].faixas_limite[0].valor_final = parseInt("0");
        }
        this.novo_poder.id_cliente = this.cliente.id_cliente;

        var valor_inicial = this.novo_poder.processos[0].faixas_limite[0].valor_inicial;
        var valor_final = this.novo_poder.processos[0].faixas_limite[0].valor_final;
        if (this.possui_limite == "sim" && valor_inicial == valor_final) {
          var limite_valido = false;
          this.svc.sbExibirNotificacao("warning", this.tl.instant("geral.mensagens.atencao"), "O valor inicial não pode ser igual ao valor final!");
        }

        if (limite_valido) {
          if (this.tipo_manutencao_poder == "I") {
            this.spinPoderesCRUD = true;
            this.svc.InserirProcessosPoderes(this.novo_poder);
            this.sub.sink = this.svc.ProcessosPoderesIncluido().subscribe((resp) => {
              if (resp == false) this.spinPoderesCRUD = false;
              else if (resp != null) {
                this.spinPoderesCRUD = false;
                this.svc.sbExibirNotificacao("success", this.tl.instant("geral.mensagens.salvo"), this.tl.instant("cadastro_poderes.mensagens.poder_incluido"));
                this.carregarPoderes();
                this.svc.sbFecharModal("modalPoderes");
              }
            });
          } else {
            this.spinPoderesCRUD = true;
            this.svc.AlterarProcessosPoderes(this.novo_poder);
            this.sub.sink = this.svc.ProcessosPoderesAlterado().subscribe((resp) => {
              if (resp == false) this.spinPoderesCRUD = false;
              else if (resp != null) {
                this.spinPoderesCRUD = false;
                this.svc.sbExibirNotificacao("success", this.tl.instant("geral.mensagens.salvo"), this.tl.instant("cadastro_poderes.mensagens.poder_alterado"));
                this.carregarPoderes();
                this.svc.sbFecharModal("modalPoderes");
              }
            });
          }
        }
      }
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
    }
  }

  //excluir poder
  public excluirPoder() {
    try {
      this.spinPoderesCRUD = true;
      this.svc.DeletarProcessosPoderes({
        id_cliente: this.cliente.id_cliente,
        id_faixa: parseInt(this.novo_poder.processos[0].faixas_limite[0].id_faixa)
      });
      this.sub.sink = this.svc.ProcessosPoderesExcluido().subscribe((resp) => {
        if (resp == false) this.spinPoderesCRUD = false;
        else if (resp != null) {
          this.spinPoderesCRUD = false;
          this.svc.sbExibirNotificacao("success", this.tl.instant("geral.mensagens.salvo"), this.tl.instant("cadastro_poderes.mensagens.poder_excluido"));
          this.carregarPoderes();
          this.svc.sbFecharModal("modalPoderes");
        }
      });
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
    }
  }

  //Inserir
  public adicionarFaixa(f: NgForm) {
    try {
      this.limparCamposPoder(f);
      this.svc.sbAbrirModal("modalPoderes");
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
    }
  }

  //Editar
  public editarFaixa(faixa, processo, f: NgForm) {
    try {
      this.limparCamposPoder(f);
      this.possui_limite = Object.assign({}, processo).possui_limite ? "sim" : "false";
      this.valor_inicial = Object.assign({}, faixa).valor_inicial;
      this.valor_final = Object.assign({}, faixa).valor_final;
      faixa.autorizadores.forEach((item, index) => {
        this.sequencia_lista.push(Object.assign({}, item));
        this.sequencia_lista[index].index = index;
      });
      this.novo_poder = {
        id_cliente: this.cliente.id_cliente,
        processos: [
          {
            id_tipo_processo: Object.assign({}, processo).id_processo,
            faixas_limite: [
              {
                id_faixa: Object.assign({}, faixa).id_faixa,
                valor_inicial: this.valor_inicial,
                valor_final: this.valor_final,
                autorizadores: this.sequencia_lista
              }
            ]
          }
        ]
      };
      this.tipo_manutencao_poder = "A";
      this.svc.sbAbrirModal("modalPoderes");
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
    }
  }

  public excluirFaixa(faixa, processo, f: NgForm) {
    try {
      this.limparCamposPoder(f);
      this.possui_limite = Object.assign({}, processo).possui_limite ? "sim" : "false";
      this.valor_inicial = Object.assign({}, faixa).valor_inicial;
      this.valor_final = Object.assign({}, faixa).valor_final;
      faixa.autorizadores.forEach((item, index) => {
        this.sequencia_lista.push(Object.assign({}, item));
        this.sequencia_lista[index].index = index;
      });
      this.novo_poder = {
        id_cliente: this.cliente.id_cliente,
        processos: [
          {
            id_tipo_processo: Object.assign({}, processo).id_processo,
            faixas_limite: [
              {
                id_faixa: Object.assign({}, faixa).id_faixa,
                valor_inicial: this.valor_inicial,
                valor_final: this.valor_final,
                autorizadores: this.sequencia_lista
              }
            ]
          }
        ]
      };
      this.tipo_manutencao_poder = "E";
      this.svc.sbAbrirModal("modalPoderes");
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
    }
  }

  //Carregar Dados
  public carregarPoderes() {
    try {
      this.spinProcessos = true;
      this.svc.CadastroProcessosPoderesPesquisar(this.cliente.id_cliente);
      this.sub.sink = this.svc.CadastroProcessosPoderes().subscribe((resp: any) => {
        if (resp == false) this.spinProcessos = false;
        else if (resp != null) {
          this.spinProcessos = false;
          this.poderes = resp.processos;
        }
      });
    } catch (e) {
      throw e;
    }
  }

  //Carregar Dados
  public carregarTiposProcesso() {
    try {
      this.svc.TipoProcessoPesquisar();
      this.sub.sink = this.svc.TipoProcesso().subscribe((resp: any) => {
        if (resp != null)
          this.tipos_processo_lista = resp.Processos;
      });
    } catch (e) {
      throw e;
    }
  }
  //#endregion

  //#region Documentos
  public novo_documento: any = {
    id_cliente: -1,
    id_documento: -1,
    desc_documento: "",
    validade_documento: "",
    nome_arquivo: "",
    tipo_conteudo: "",
    mime: "",
    binario_arquivo: null
  };

  public limparFormDocs(f: NgForm, data) {
    f.reset();
    this.docAnexo = [];
    this.dropVazio = false;

    var that = this;
    setTimeout(() => {
      if (data == null) {
        that.novo_documento = {
          id_cliente: -1,
          id_documento: -1,
          desc_documento: "",
          validade_documento: "",
          nome_arquivo: "",
          tipo_conteudo: "",
          mime: "",
          binario_arquivo: null
        };
      } else {
        that.novo_documento = data;
      }
    }, 100);
  }

  //Processar Dados
  public salvarDocumento(f: NgForm) {
    try {
      //Verifica se o FOrmulário está Válido
      if (f.valid) {
        if (this.docAnexo.length == 0) {
          this.dropVazio = true;
          this.svc.sbExibirNotificacao("warning", this.tl.instant("geral.mensagens.atencao"), this.tl.instant("cadastro_poderes.mensagens.subir_arquivo"));
        } else {
          this.novo_documento.id_cliente = this.cliente.id_cliente;
          if (this.tipo_manutencao_docs == "I") {
            this.spinUploadCRUD = true;
            this.svc.InserirDocumentoPoderes(this.novo_documento);
            this.sub.sink = this.svc.DocumentoPoderIncluido().subscribe((resp) => {
              if (resp == false) this.spinUploadCRUD = false;
              else if (resp != null) {
                this.spinUploadCRUD = false;
                this.svc.sbExibirNotificacao("success", this.tl.instant("geral.mensagens.salvo"), this.tl.instant("cadastro_poderes.mensagens.documento_incluido"));
                this.carregarDocumentos();
              }
            });
          } else {
            this.spinUploadCRUD = true;
            this.svc.AlterarDocumentoPoderes(this.novo_documento);
            this.sub.sink = this.svc.DocumentoPoderAlterado().subscribe((resp) => {
              if (resp == false) this.spinUploadCRUD = false;
              else if (resp != null) {
                this.spinUploadCRUD = false;
                this.svc.sbExibirNotificacao("success", this.tl.instant("geral.mensagens.salvo"), this.tl.instant("cadastro_poderes.mensagens.documento_alterado"));
                this.carregarDocumentos();
              }
            });
          }
          this.svc.sbFecharModal("modalDocumentosCRUD");
        }
      } else {
        //Marca todos os campos como Inválidos
        (<any>Object).values(f.controls).forEach(control => {
          control.markAsTouched();
        });
        this.dropVazio = false;
        this.svc.sbExibirNotificacao("warning", this.tl.instant("geral.mensagens.atencao"), this.tl.instant("geral.mensagens.campos_obrigatorios"));
      }
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
    }
  }

  //Processar Dados
  public excluirDocumento() {
    try {
      this.spinUploadCRUD = true;
      this.novo_documento.id_cliente = this.cliente.id_cliente;
      this.svc.ExcluirDocumentoPoderes(this.novo_documento);
      this.sub.sink = this.svc.DocumentoPoderExcluido().subscribe((resp) => {
        if (resp == false) this.spinUploadCRUD = false;
        else if (resp != null) {
          this.spinUploadCRUD = false;
          this.svc.sbExibirNotificacao("success", this.tl.instant("geral.mensagens.salvo"), this.tl.instant("cadastro_poderes.mensagens.documento_excluido"));
          this.carregarDocumentos();
        }
      });
      this.svc.sbFecharModal("modalDocumentosCRUD");
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
    }
  }

  //Criar
  public adicionarDocumento(f: NgForm) {
    try {
      this.limparFormDocs(f, null);
      this.tipo_manutencao_docs = "I";
      this.svc.sbAbrirModal("modalDocumentosCRUD");
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
    }
  }

  //Remover
  public removerDocumento(data, f: NgForm) {
    try {
      this.limparFormDocs(f, Object.assign({}, data));
      this.tipo_manutencao_docs = "E";
      this.svc.sbAbrirModal("modalDocumentosCRUD");
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
    }
  }

  //Editar
  public editarDocumento(data, f: NgForm) {
    try {
      this.limparFormDocs(f, Object.assign({}, data));
      this.tipo_manutencao_docs = "A";

      this.spinUploadCRUD = true;
      this.svc.DocumentosPoderesBinarioPesquisar(data.id_documento);
      this.sub.sink = this.svc.DocumentoPoderBinario().subscribe((resp: any) => {
        if (resp == false) this.spinUploadCRUD = false;
        else if (resp != null) {
          this.spinUploadCRUD = false;
          var imageBase64 = "base64," + resp.arquivo;
          var blob = new Blob(imageBase64.split(''), { type: resp.tipo_conteudo });
          var file = new File([blob], data.nome_arquivo);
          this.docAnexo = [];
          this.docAnexo.push(file);
          this.novo_documento.binario_arquivo = resp.arquivo;
          this.novo_documento.mime = resp.mime;
          this.novo_documento.tipo_conteudo = resp.tipo_conteudo;
        }
      });

      this.svc.sbAbrirModal("modalDocumentosCRUD");
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
    }
  }

  //Carregar Dados
  public carregarDocumentos() {
    try {
      this.spinDoc = true;
      this.svc.DocumentosPoderesPesquisar(this.cliente.id_cliente);
      this.sub.sink = this.svc.CadastroDocumentosPoderes().subscribe((resp: any) => {
        if (resp == false) this.spinDoc = false;
        else if (resp != null) {
          this.spinDoc = false;
          this.documentos = resp.documentos;
          this.documentos_lista = [];
          resp.documentos.forEach(item => {
            this.documentos_lista.push({
              label: item.desc_documento,
              value: {
                id_documento: item.id_documento,
                desc_documento: item.desc_documento
              }
            });
          });
        }
      });
    } catch (e) {
      throw e;
    }
  }

  public sbCarregarIdiomaTBDocs() {
    this.colsDocs = [
      { type: 'edit', filter: false, filter_type: 'multi-select', header: '', field: 'id_documento', size: '4%', text_align: 'text-left' },
      { type: 'remove', filter: false, filter_type: 'multi-select', header: '', field: 'id_documento', size: '4%', text_align: 'text-left' },
      { type: 'text', filter: true, filter_type: 'multi-select', header: this.tl.instant("cadastro_poderes.documentos_tabela.documento"), field: 'desc_documento', size: '47%', text_align: 'text-left' },
      { type: 'link', filter: true, filter_type: 'multi-select', header: this.tl.instant("cadastro_poderes.documentos_tabela.anexo"), field: 'nome_arquivo', size: '43%', text_align: 'text-left' },
      { type: 'data', filter: true, filter_type: 'data', header: this.tl.instant("cadastro_poderes.documentos_tabela.validade"), field: 'validade_documento', size: '20%', text_align: 'text-left' }
    ];
  }

  public onSelectDoc(event) {
    try {
      this.docAnexo = [];
      this.docAnexo.push(...event.addedFiles);
      let that = this;

      if (this.docAnexo[0]) {
        var reader = new FileReader();
        reader.onload = function (e: any) {
          if (e.target.result.indexOf("base64,") != -1) {
            that.novo_documento.binario_arquivo = e.target.result.split("base64,")[1];
          } else {
            that.novo_documento.binario_arquivo = e.target.result;
          }
          that.novo_documento.nome_arquivo = that.docAnexo[0].name;
          that.novo_documento.mime = that.docAnexo[0].type;
          that.novo_documento.tipo_conteudo = that.docAnexo[0].type;
        };
        reader.readAsDataURL(this.docAnexo[0]);
      }
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
    }
  }

  public onRemoveDoc(event) {
    try {
      this.docAnexo.splice(this.docAnexo.indexOf(event), 1);
      this.novo_documento.binario_arquivo = null;
      this.novo_documento.nome_arquivo = "";
      this.novo_documento.mime = "";
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
    }
  }

  public bytesToSize(bytes): string {
    try {
      if (bytes >= 1073741824) { bytes = (bytes / 1073741824).toFixed(2) + " GB"; }
      else if (bytes >= 1048576) { bytes = (bytes / 1048576).toFixed(2) + " MB"; }
      else if (bytes >= 1024) { bytes = (bytes / 1024).toFixed(2) + " KB"; }
      else if (bytes > 1) { bytes = bytes + " bytes"; }
      else if (bytes == 1) { bytes = bytes + " byte"; }
      else { bytes = "0 bytes"; }
      return bytes;
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
    }
  }

  //Download do Arquivo
  public downloadFile(data) {
    
    try {
      const base64ImageData: string = data.binario_arquivo;

      this.svc.DocumentosPoderesBinarioPesquisar(data.id_documento);
      this.sub.sink = this.svc.DocumentoPoderBinario().subscribe((resp: any) => {
        if (resp != null) {
          const byteCharacters = atob(resp.arquivo);
          const byteArrays = [];

          for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
            const slice = byteCharacters.slice(offset, offset + 1024);

            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
              byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
          }
          console.log(resp);
          const blob = new Blob(byteArrays, { type: resp.tipo_conteudo });
          const blobUrl = URL.createObjectURL(blob);
          window.open(blobUrl, '_blank');
        }
      });
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
    }
  }
  //#endregion

  //#region Autorizadores
  public novo_autorizador: any = {
    id_cliente: -1,
    id_autorizador: -1,
    nome_autorizador: "",
    documento: "",
    email_principal: "",
    email_aviso: "",
    cargo: "",
    celular: "",
    procurador: false,
    data_nascimento: "",
    ind_autorizador_master: false
  };

  public limparFormAutorizador(f: NgForm, data) {
    f.reset();

    var that = this;
    setTimeout(() => {
      if (data == null)
        that.novo_autorizador = {
          id_cliente: -1,
          id_autorizador: -1,
          nome_autorizador: "",
          documento: "",
          email_principal: "",
          email_aviso: "",
          cargo: "",
          celular: "",
          procurador: false,
          data_nascimento: "",
          ind_autorizador_master: false
        };
      else
        that.novo_autorizador = data;
    }, 100);
  }

  //Processar Dados
  public salvarAutorizador(f: NgForm) {
    try {
      //Verifica se o FOrmulário está Válido
      if (f.valid) {
        this.novo_autorizador.id_cliente = this.cliente.id_cliente;
        if (this.tipo_manutencao_autorizadores == "I") {
          this.spinAutoCRUD = true;
          this.svc.InserirAutorizador(this.novo_autorizador);
          this.sub.sink = this.svc.AutorizadorIncluido().subscribe((resp) => {
            if (resp == false) this.spinAutoCRUD = false;
            else if (resp != null) {
              this.spinAutoCRUD = false;
              this.svc.sbExibirNotificacao("success", this.tl.instant("geral.mensagens.salvo"), this.tl.instant("cadastro_poderes.mensagens.autorizador_incluido"));
              this.carregarAutorizadores();
            }
          });
        } else {
          this.spinAutoCRUD = true;
          this.svc.AlterarAutorizador(this.novo_autorizador);
          this.sub.sink = this.svc.AutorizadorAlterado().subscribe((resp) => {
            if (resp == false) this.spinAutoCRUD = false;
            else if (resp != null) {
              this.spinAutoCRUD = false;
              this.svc.sbExibirNotificacao("success", this.tl.instant("geral.mensagens.salvo"), this.tl.instant("cadastro_poderes.mensagens.autorizador_alterado"));
              this.carregarAutorizadores();
            }
          });
        }
        this.svc.sbFecharModal("modalAutorizadoresCRUD");
      } else {
        //Marca todos os campos como Inválidos
        (<any>Object).values(f.controls).forEach(control => {
          control.markAsTouched();
        });
        this.svc.sbExibirNotificacao("warning", this.tl.instant("geral.mensagens.atencao"), this.tl.instant("geral.mensagens.campos_obrigatorios"));
      }
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
    }
  }

  //Processar Dados
  public excluirAutorizador() {
    try {
      this.novo_autorizador.id_cliente = this.cliente.id_cliente;
      this.spinAutoCRUD = true;
      this.svc.ExcluirAutorizador(this.novo_autorizador);
      this.sub.sink = this.svc.AutorizadorExcluido().subscribe((resp) => {
        if (resp == false) this.spinAutoCRUD = false;
        else if (resp != null) {
          this.spinAutoCRUD = false;
          this.svc.sbExibirNotificacao("success", this.tl.instant("geral.mensagens.salvo"), this.tl.instant("cadastro_poderes.mensagens.autorizador_excluido"));
          this.carregarAutorizadores();
        }
      });
      this.svc.sbFecharModal("modalAutorizadoresCRUD");
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
    }
  }

  //Carregar Dados
  public carregarAutorizadores() {
    try {
      this.spinAuto = true;
      this.carregarProcuradores();
      this.svc.AutorizadoresPesquisar(this.cliente.id_cliente);
      this.sub.sink = this.svc.CadastroAutorizadores().subscribe((resp) => {
        if (resp == false) this.spinAuto = false;
        else if (resp != null) {
          this.spinAuto = false;
          this.autorizadores = resp;
        }
      });
    } catch (e) {
      throw e;
    }
  }

  public carregarProcuradores() {
    try {
      this.svc.ProcuradoresPesquisar(this.cliente.id_cliente);
      this.sub.sink = this.svc.CadastroProcuradores().subscribe((resp) => {
        if (resp != null) {
          this.procuradores_lista = resp;
        }
      });
    } catch (e) {
      throw e;
    }
  }

  //Criar
  public adicionarAutorizador(f: NgForm) {
    try {
      this.limparFormAutorizador(f, null);
      this.tipo_manutencao_autorizadores = "I";
      this.svc.sbAbrirModal("modalAutorizadoresCRUD");
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
    }
  }

  //Remover
  public removerAutorizador(data, f: NgForm) {
    try {
      this.limparFormAutorizador(f, Object.assign({}, data));
      this.tipo_manutencao_autorizadores = "E";
      this.svc.sbAbrirModal("modalAutorizadoresCRUD");
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
    }
  }

  //Editar
  public editarAutorizador(data, f: NgForm) {
    try {
      this.limparFormAutorizador(f, Object.assign({}, data));
      this.tipo_manutencao_autorizadores = "A";
      this.svc.sbAbrirModal("modalAutorizadoresCRUD");
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
    }
  }

  public sbCarregarIdiomaTBAutorizadores() {
    this.colsAutorizadores = [
      { type: 'edit', filter: false, filter_type: 'multi-select', header: '', field: 'id_autorizador', size: '3%', text_align: 'text-right' },
      { type: 'remove', filter: false, filter_type: 'multi-select', header: '', field: 'id_autorizador', size: '3%', text_align: 'text-left' },
      { type: 'text', filter: true, filter_type: 'multi-select', header: this.tl.instant("cadastro_poderes.autorizadores_tabela.nome"), field: 'nome_autorizador', size: '18%', text_align: 'text-left' },
      { type: 'text', filter: true, filter_type: 'multi-select', header: this.tl.instant("cadastro_poderes.autorizadores_tabela.documento"), field: 'documento', size: '12%', text_align: 'text-left' },
      { type: 'text', filter: true, filter_type: 'multi-select', header: this.tl.instant("cadastro_poderes.autorizadores_tabela.email_principal"), field: 'email_principal', size: '15%', text_align: 'text-left' },
      { type: 'text', filter: true, filter_type: 'multi-select', header: this.tl.instant("cadastro_poderes.autorizadores_tabela.email_aviso"), field: 'email_aviso', size: '15%', text_align: 'text-left' },
      { type: 'text', filter: true, filter_type: 'multi-select', header: this.tl.instant("cadastro_poderes.autorizadores_tabela.papel"), field: 'cargo', size: '12%', text_align: 'text-left' },
      { type: 'text', filter: true, filter_type: 'multi-select', header: this.tl.instant("cadastro_poderes.autorizadores_tabela.celular"), field: 'celular', size: '12%', text_align: 'text-left' },
      { type: 'checkbox', filter: true, filter_type: 'multi-select', header: 'Master', field: 'ind_autorizador_master', size: '10%', text_align: 'text-center' }
    ];
  }
  //#endregion

  ngOnInit() {
    try {
      this.carregarTiposProcesso();
      this.sub.sink = this.activatedRoute.params.subscribe(params => {
        if (params) {
          this.cliente = JSON.parse(params['cliente']);
          this.carregarAutorizadores();
          this.carregarDocumentos();
          this.carregarPoderes();
        }
      });

      //É chamado sempre que o Idioma for Mudado
      this.sub.sink = this.svc.sbGetTraducaoAuto("cadastro_poderes.autorizadores_tabela").subscribe((resp) => {
        this.sbCarregarIdiomaTBAutorizadores();
      });
      this.sub.sink = this.svc.sbGetTraducaoAuto("cadastro_poderes.documentos_tabela").subscribe((resp) => {
        this.sbCarregarIdiomaTBDocs();
      });
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.ops"), this.tl.instant("geral.suporte"));
    }
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
